import React from 'react'
import iconorange from '../images/icon_orange.svg';
import AnimatedText5 from './AnimatedText5'

const ProcessSection = () => {
  return (
    <div>
         <section id="process">
                <div className='container-xxl process-container'>
                    <div className='text-box' data-aos="fade-up" data-aos-once="true">
                        <img id="processimg" className='icon_orange' src={iconorange} alt='icon-orange' />
                        <p>Our process</p>
                    </div>

                    <AnimatedText5 />

                    <div className='process-box'>
                        <div className="container-fluid">
                            <div className="row firstrow firstr">
                                <div className="col-md-6 col-12 firstcol">
                                    <div className='column col1'>
                                        <div className='content-box'>
                                            <div className='count'>
                                                <p>1</p>
                                            </div>
                                            <h5>Book Call</h5>
                                            <p>Schedule a discovery call, and let’s explore the best ways we can support your needs!</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-12 firstcol">
                                    <div className='column col2'>
                                        <div className='content-box'>
                                            <div className='count'>
                                                <p>2</p>
                                            </div>
                                            <h5>Development and design</h5>
                                            <p>Get your landing page and website shipped before discussed deadline.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row firstrow">
                                <div className="col-12 firstcol">
                                    <div className='column col3'>
                                        <div className='content-box'>
                                            <div className='count'>
                                                <p>3</p>
                                            </div>
                                            <h5>Satisfaction</h5>
                                            <p>Request design revisions until you're completely thrilled with the results and ready to launch your project with confidence! Your satisfaction is our priority.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    </div>
  )
}

export default ProcessSection